import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  OnVisible, ONE_CMS_API, Anchor, Button, CompleteTransaction,
} from '@americanexpress/gravity-core';

const GravityFooter = (props) => {
  const {
    gemUrl, flow, updateSpinner, currentScreenId,
    queryParams, processPayAuthApi, settingsData, settingsClicked, changeLang,
    showDialog, updateShowDialog,
  } = props;
  const [data, setData] = useState({});
  const [cmsLoaded, setCmsLoaded] = useState(false);
  const [completeTransaction, setCompleteTransaction] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    const currentLang = changeLang || flow.setting.preferredLanguage;
    const apiUrl = `${gemUrl}${ONE_CMS_API}/${currentLang}-${flow.countryCode}/footer.json`;

    fetch(apiUrl, { signal })
      .then((res) => res.json())
      .then((footerData) => {
        setData(footerData);
        setCmsLoaded(true);
      })
      .catch(() => null);

    return () => {
      abortController.abort();
    };
  }, [changeLang]);

  const handleOpenWindow = (url) => {
    window.open(url, '', 'top=400,left=650,width=610,height=430,resizable=yes,scrollbars=yes,titlebar=no,toolbar=no,menubar=no');
  };

  const handleCompleteTxn = () => {
    if (showDialog) {
      updateShowDialog(false);
    }
    updateSpinner(true);
    setCompleteTransaction(true);
  };

  if (!cmsLoaded) {
    return null;
  }

  if (completeTransaction) {
    return (
      <CompleteTransaction
        screenId={currentScreenId}
        processPayAuthApi={processPayAuthApi}
        eventCode="cancel"
        btnId="cancelTxnFooterBtn"
        queryParams={queryParams}
        settingsClicked={settingsClicked}
        settingsData={settingsData}
        preferredLang={changeLang || flow.setting.preferredLanguage}
      />
    );
  }

  return (
    <OnVisible
      identifier="axp-gravity-footer"
      acsTransId={queryParams.acsTransId}
      screenId={currentScreenId}
    >
      <div id="skFooter" className="safekey-footer flex flex-justify-center flex-align-center legal-1 dls-white-bg">
        <footer className="text-align-center">
          {data.actions.cancelTransaction.text
            && (
              <Fragment>
                <Button
                  className="toggle-link"
                  type="button"
                  id="cancelTxnBtn"
                  onClick={handleCompleteTxn}
                  aria-label={data.actions.cancelTransaction.aria}
                  identifier="axp-gravity-footer"
                  element="cancelTxnFooterBtn"
                  detail={data.actions.cancelTransaction.text}
                  acsTransId={queryParams.acsTransId}
                  screenId={currentScreenId}
                >
                  {data.actions.cancelTransaction.text}
                </Button>
                <span className="dls-gray-05 safekey-margin-sm">|</span>
              </Fragment>
            )}
          {data.footerLinks.map((item, i) => item.text && (
          <Fragment key={item.text}>
            <Anchor
              href={item.url}
              target="_blank"
              rel="noreferrer noopener"
              id={`footerLink${i}`}
              identifier="axp-gravity-footer"
              element={`footerLink${i}`}
              detail={item.text}
              acsTransId={queryParams.acsTransId}
              screenId={currentScreenId}
            >
              <span aria-label={item.aria}>
                {item.text}
              </span>
            </Anchor>
            {i < data.footerLinks.length - 1 && data.footerLinks[i + 1].text && <span className="dls-gray-05 safekey-margin-sm">|</span>}
          </Fragment>
          )
          )}
          {data.tAndC && data.tAndC.text && (
            <Fragment>
              {(data.footerLinks.length > 0 || data.actions.cancelTransaction.text) && <span className="dls-gray-05 safekey-margin-sm">|</span>}
              <Button
                className="toggle-link"
                type="button"
                id="footerTandC"
                onClick={() => handleOpenWindow(data.tAndC.url)}
                aria-label={data.tAndC.aria}
                identifier="axp-gravity-footer"
                element="footerTandC"
                detail={data.tAndC.text}
                acsTransId={queryParams.acsTransId}
                screenId={currentScreenId}
              >
                {data.tAndC.text}
              </Button>
            </Fragment>
          )}
        </footer>
      </div>
    </OnVisible>
  );
};

GravityFooter.propTypes = {
  gemUrl: PropTypes.string.isRequired,
  flow: PropTypes.shape({
    flow: PropTypes.string,
    setting: PropTypes.shape({
      preferredLanguage: PropTypes.string,
    }),
    countryCode: PropTypes.string.isRequired,
  }),
  updateSpinner: PropTypes.func.isRequired,
  currentScreenId: PropTypes.string.isRequired,
  queryParams: PropTypes.shape({
    acsTransId: PropTypes.string,
  }).isRequired,
  updateShowDialog: PropTypes.func.isRequired,
  showDialog: PropTypes.bool.isRequired,
  processPayAuthApi: PropTypes.func.isRequired,
  settingsClicked: PropTypes.bool.isRequired,
  settingsData: PropTypes.string.isRequired,
  changeLang: PropTypes.string.isRequired,
};

GravityFooter.defaultProps = {
  flow: {},
};

export default GravityFooter;
